import { Button, IconButton } from '@mui/material';
import { ForwardedRef, forwardRef } from 'react';

import { CustomLink } from './custom-link';

type ButtonProps = React.ComponentProps<typeof Button>;

export interface CustomButtonProps extends ButtonProps {
  startIconMargin?: string;
  endIconMargin?: string;
  iconOnly?: boolean;
  fontSize?: number | string;
  target?: React.HTMLAttributeAnchorTarget;
  align?: 'start' | 'center' | 'end';
  noPadding?: boolean;
}

export const CustomButton = forwardRef(
  (props: CustomButtonProps, ref: ForwardedRef<HTMLButtonElement>) => {
    const {
      children,
      iconOnly,
      startIconMargin,
      endIconMargin,
      fontSize = 16,
      align = 'center',
      noPadding,
      ...rest
    } = props;

    const noPaddingStyles = {
      padding: 0,
      height: 'fit-content',
      minWidth: 'auto',
      backgroundColor: 'transparent',
    };

    return iconOnly ? (
      <IconButton
        LinkComponent={CustomLink}
        disableRipple
        ref={ref}
        sx={{ ...(noPadding ? noPaddingStyles : {}), ...rest.sx }}
        {...rest}
      >
        {children}
      </IconButton>
    ) : (
      <Button
        {...rest}
        LinkComponent={CustomLink}
        sx={{
          '& .MuiButton-startIcon': {
            marginRight: startIconMargin ?? '8px',
            marginLeft: 0,
          },
          '& .MuiButton-endIcon': {
            marginLeft: endIconMargin ?? '8px',
          },
          fontSize,
          justifyContent: align,
          paddingInline: align !== 'center' ? 0 : undefined,
          ...(noPadding ? noPaddingStyles : {}),
          ...rest.sx,
        }}
        disableRipple
        ref={ref}
      >
        {children}
      </Button>
    );
  },
);
